/* XIIW V11: single-open tabs with mobile close-again behavior. */
(function () {
  'use strict';
  document.addEventListener('change', function (event) {
    var control = event.target;
    if (!control || !control.matches || !control.matches('.xiiw-product-info-section .xiiw-product-info-radio')) return;
    var group = control.closest('.xiiw-product-info-tabs');
    if (!group) return;
    if (control.checked) {
      group.querySelectorAll('.xiiw-product-info-radio').forEach(function (other) {
        if (other !== control) other.checked = false;
      });
    } else if (window.matchMedia('(min-width: 720px)').matches) {
      // Desktop remains radio-like: exactly one tab stays selected.
      control.checked = true;
    }
  });
}());
